import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';

var HeaderDropdown = function HeaderDropdown(_ref) {
  var title = _ref.title,
      elements = _ref.elements;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var handleOnClick = function handleOnClick(onClick) {
    onClick();
    setExpanded(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: 'pwd-header-dropdown' + (expanded ? ' pwd-expanded' : '')
  }, title && /*#__PURE__*/React.createElement("button", {
    className: "pwd-dropbtn",
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "pwd-dropdown-content"
  }, elements.map(function (_ref2) {
    var item = _ref2.item,
        _onClick = _ref2.onClick,
        key = _ref2.key;
    return /*#__PURE__*/React.createElement("a", {
      href: "#",
      key: key,
      onClick: function onClick() {
        return handleOnClick(_onClick);
      }
    }, item);
  })));
};

export default HeaderDropdown;